module.exports = require("./ar-QA");